import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const ProductCarousel = lazy(() => import('./components/ProductCarousel').then(m => ({
  default: m.ProductCarousel
})));
const CountdownTimer = lazy(() => import('./components/CountdownTimer').then(m => ({
  default: m.CountdownTimer
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const SistemaOperativoSection = lazy(() => import('./components/SistemaOperativoSection').then(m => ({
  default: m.SistemaOperativoSection
})));
const ComparisonTableExtended = lazy(() => import('./components/ComparisonTableExtended').then(m => ({
  default: m.ComparisonTableExtended
})));
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
export function App() {
  useEffect(() => {
    // Performance hints
    const preconnects = [{
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    }, {
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossOrigin: 'anonymous'
    }];
    preconnects.forEach(attrs => {
      const link = document.createElement('link');
      Object.entries(attrs).forEach(([key, val]) => link.setAttribute(key, val as string));
      document.head.appendChild(link);
    });
    // Meta Pixel Initialization
    const pixelId = '1550383169308919';
    if (!window.fbq) {
      ;
      (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        // Safe insertion: prefer the first <script> sibling, otherwise
        // fall back to <head>/<body> which always exist. This avoids
        // "Cannot read properties of undefined (reading 'parentNode')"
        // in environments that render without an initial <script> tag.
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.body || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', pixelId);
      window.fbq('track', 'PageView');
    }
    // UTMify Integration
    const utmifyScript = document.createElement('script');
    utmifyScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmifyScript.setAttribute('data-utmify-prevent-xcod-sck', '');
    utmifyScript.setAttribute('data-utmify-prevent-subids', '');
    utmifyScript.async = true;
    utmifyScript.defer = true;
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(utmifyScript, firstScript);
    } else {
      ;
      (document.head || document.body || document.documentElement).appendChild(utmifyScript);
    }
  }, []);
  return <div className="min-h-screen bg-brand-warm-white font-sans selection:bg-brand-gold-warm selection:text-white text-brand-dark-grey overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />

      <div className="bg-brand-soft-cream" data-id="element-2">
        <SocialProof data-id="element-3" />
      </div>

      <Suspense fallback={<div className="h-40 bg-brand-warm-white" data-id="element-5" />} data-id="element-4">
        <div className="bg-brand-warm-white section-spacing" data-id="element-6">
          <ProblemSection data-id="element-7" />
        </div>

        <div className="bg-brand-soft-cream section-spacing" data-id="element-8">
          <BonusSection data-id="element-9" />
        </div>

        <div className="bg-brand-warm-white py-6 md:py-12" data-id="element-10">
          <ProductCarousel data-id="element-11" />
        </div>

        <div className="bg-brand-soft-cream py-8" data-id="element-12">
          <CountdownTimer data-id="element-13" />
        </div>

        <div className="bg-brand-warm-white section-spacing" data-id="element-14">
          <PricingSection data-id="element-15" />
        </div>

        <div className="bg-brand-warm-white section-spacing" data-id="element-16">
          <ComparisonTableExtended data-id="element-17" />
        </div>

        <div className="bg-brand-warm-white section-spacing" data-id="element-18">
          <TestimonialsSection data-id="element-19" />
        </div>

        <div className="bg-brand-soft-cream section-spacing" data-id="element-20">
          <FinalCTA data-id="element-21" />
        </div>

        <div className="bg-brand-warm-white section-spacing" data-id="element-22">
          <FAQ data-id="element-23" />
        </div>

        <div className="bg-brand-soft-cream section-spacing" data-id="element-24">
          <Guarantee data-id="element-25" />
        </div>

        <div className="bg-brand-warm-white section-spacing border-t border-brand-petroleum/5" data-id="element-26">
          <div className="max-w-xl mx-auto px-5 text-center" data-id="element-27">
            <p className="text-brand-medium-grey text-sm font-medium uppercase tracking-widest mb-4" data-id="element-28">
              PORQUE UNA COSA ES TENER UN MAZO.
            </p>
            <h2 className="text-2xl md:text-3xl font-bold text-brand-petroleum mb-6 leading-tight" data-id="element-29">
              Y otra muy distinta es comprender lo que las cartas tienen para
              decirte.
            </h2>
            <p className="text-brand-dark-grey text-lg italic" data-id="element-30">
              Tu próxima lectura puede ser la primera que realmente entiendas.
            </p>
          </div>
        </div>

        <PurchasePopup data-id="element-31" />
      </Suspense>

      <footer className="bg-brand-warm-white py-12 border-t border-brand-petroleum/5 text-center" data-id="element-32">
        <p className="text-[10px] text-brand-medium-grey font-semibold uppercase tracking-[0.3em]" data-id="element-33">
          © 2026 MÉTODO TAROT LISTO™ — TODOS LOS DERECHOS RESERVADOS
        </p>
      </footer>
    </div>;
}